import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { GlobalServicesService } from '../services/global-services.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router, 
    private globalService: GlobalServicesService
  ) { }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    if (localStorage.getItem('tokenFastApi')) {
      this.globalService.getUserProfileFastApi().subscribe({
        next: (res: any) => {
          const privilege = res.body.auth_user_permissions || [];
          const dashboardEnabled = res.body.company_metadata?.company_config?.dashboard ?? false;
          const hasEventAccess = privilege.includes('event.view') || privilege.includes('event.create');
          
          let redirectPath = '/settings';
          
          if (dashboardEnabled === true) {
            redirectPath = '/dashboard';
          } else if (hasEventAccess) {
            redirectPath = '/events';
          }
          
          this.router.navigateByUrl(redirectPath);
        },
        error: (error) => {
          console.log('Error fetching user profile:', error);
          this.router.navigate(['/events']);
        }
      });
      return false;
    }
    return true;
  }
}
